import {Injectable} from '@angular/core';

@Injectable()
export class StorageService {
    private CIRCLE_WIDTH_KEY = 'circleWidthKey';

    setCircleWidth(width) {
        sessionStorage.setItem(this.CIRCLE_WIDTH_KEY, width);
    }

    getCircleWidth() {
        return +sessionStorage.getItem(this.CIRCLE_WIDTH_KEY);
    }
}
